<script>
  import { scaleLinear } from "d3-scale";
  import Number from "./Number.svelte";
  import data from "./../data/causes-of-death.json";
  import {
    bar_chart_heading,
    bar_chart_climate_change_label,
    bar_chart_footer
  } from "./../content/data.json";
  import warmingDeathratesRaw from "./../data/deathrates_fulladapt_rcp85_global_all_years_unstacked.csv";

  export let year = 2099;

  let warmingDeathrates = {};
  Object.keys(warmingDeathratesRaw[0])
    .filter(d => d)
    .forEach(year => {
      warmingDeathrates[year] = +warmingDeathratesRaw[0][year];
    });

  const climateChangeKey = "climate-change";
  const causes = [climateChangeKey, ...Object.keys(data)];

  const rowHeight = 43;

  $: xScale = scaleLinear()
    .domain([0, Math.max(...Object.values(data))])
    .range([0, 100]);

  let causeStats = {};
  const updateCauseStats = () => {
    causeStats = {};
    causes.forEach(cause => {
      const deaths =
        (cause == climateChangeKey ? warmingDeathrates[year] : data[cause]) ||
        0;
      causeStats[cause] = {
        width: xScale(deaths),
        deaths
      };
    });

    let sortedCauses = causes.sort(
      (a, b) => causeStats[b].deaths - causeStats[a].deaths
    );
    causes.forEach(cause => {
      const index = sortedCauses.indexOf(cause);
      causeStats[cause] = {
        ...causeStats[cause],
        index,
        y: index * rowHeight
      };
    });
  };

  $: year, xScale, updateCauseStats();
</script>

<div class="c">
  <h6>{bar_chart_heading}</h6>
  <figure class="figure" style="{`height: ${causes.length * rowHeight}px`}">
    {#each causes as cause (cause)}
      <div
        class="row"
        style="{`transform: translateY(${causeStats[cause].y}px)`}">
        <div class="label" class:active="{cause == climateChangeKey}">
          {cause == climateChangeKey ? bar_chart_climate_change_label : cause}
        </div>
        <div class="bar">
          <div
            class="bar-fill"
            class:active="{cause == climateChangeKey}"
            style="{`width: ${causeStats[cause].width}%`}">
            <div class="bar-label">
              <Number number="{causeStats[cause].deaths}" format=",.0f" />
            </div>
          </div>
        </div>
      </div>
    {/each}
  </figure>
  <div class="footer">{bar_chart_footer}</div>
</div>

<style>
  h6 {
    text-align: left;
    margin-bottom: 0.9em;
    font-weight: 800;
  }
  .c {
    position: relative;
    margin: 2em auto 5em;
    width: 100%;
    max-width: 40em;
  }
  .wrapper {
    position: relative;
    width: 100%;
  }
  .row {
    position: absolute;
    width: 100%;
    left: 0;
    display: flex;
    align-items: center;
    padding: 0.5em 0;
    transition: all 0.5s ease-out;
  }
  .label {
    flex: 0 0 20em;
    text-align: left;
    /* font-weight: 700; */
  }
  .label.active {
    color: var(--c2);
    font-weight: 800;
  }
  .bar {
    position: relative;
    flex: 1;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bar-fill {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    background: #487588;
    /* background: #383570; */
    border-radius: 0 3px 3px 0;
  }
  .bar-fill.active {
    background: white;
    color: var(--c2);
  }
  .bar-label {
    text-align: left;
    line-height: 28px;
    margin-left: 0.6em;
    font-feature-settings: "tnum", "zero";
  }
  .footer {
    max-width: 30em;
    margin-top: 2em;
    margin-left: auto;
    font-size: 0.8em;
    line-height: 1.3em;
    text-align: right;
    opacity: 0.6;
  }

  @media (max-width: 650px) {
    .row {
      flex-direction: column;
      text-align: left;
    }
    .label {
      flex: none;
      text-align: right;
      position: absolute;
      right: 1em;
      top: 50%;
      max-width: 80%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: 600;
      font-size: 0.9em;
      transform: translateY(-50%);
      margin-top: 0;
      z-index: 10;
    }
    .bar {
      width: 100%;
      flex: none;
      height: 41px;
    }
    .bar-label {
      line-height: 41px;
    }
  }
</style>
